import React from 'react';
import NetworkIcon from '@components/NetworkIcon';
import { Network } from '@types';
import { shortenAddress } from '@lib/utils';

interface FeeInfoProps {
  address: string;
  addressNetwork: Network;
  amount: string;
}

const FeeInfo = ({ address, addressNetwork, amount }: FeeInfoProps) => {
  return (
    <div className="p-3 w-full text-white">
      <div className="flex flex-wrap content-center text-body">
        <div className="text-left w-1/2 tablet:w-2/5">Bridge network fees</div>
        <div className="text-right w-1/2 tablet:w-3/5">{amount}</div>
      </div>
      <div className="mt-1 flex flex-wrap content-center text-body">
        <div className="text-left w-1/2 tablet:w-2/5">Destination</div>
        <div className="text-right w-1/2 tablet:w-3/5 justify-end flex flex-row">
          <div className="text-body flex flex-wrap content-center">
            <NetworkIcon variant={addressNetwork} />
          </div>
          <div className="ml-1">{shortenAddress(address)}</div>
        </div>
      </div>
    </div>
  );
};

export default FeeInfo;
